var _path, _path2, _path3, _circle, _path4, _circle2, _path5, _circle3, _path6, _circle4, _path7, _circle5, _path8, _path9, _circle6, _path10, _path11, _path12, _path13, _path14, _circle7, _path15, _circle8, _path16, _circle9, _path17, _circle10, _path18, _circle11, _path19, _circle12, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268.243,
    height: 230.478,
    viewBox: "0 0 268.243 230.478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_6260",
    "data-name": "Group 6260",
    transform: "translate(-1304.001 -387.483)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7115",
    "data-name": "Path 7115",
    d: "M1219.023,869.38c-50.635-22.559-67.713-93.485-47.293-144.9,22.646-57.017,84.39-72.347,95-74.755,36.915-8.379,101.381-7.088,126.916,35.494,28.379,47.326-12.264,110.745-40.3,139.341C1346,832.06,1280.684,896.851,1219.023,869.38Z",
    transform: "translate(166.655 -258.167)",
    fill: "#ecf3fe",
    opacity: 0.56
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7116",
    "data-name": "Path 7116",
    d: "M2198.031,1064l-111.973-34.347,28.217-102.251,116.012,19.736Zm-110.815-34.983,110.161,33.792L2229.094,947.9,2114.96,928.485Z",
    transform: "translate(-679.1 -516.414)",
    fill: "#536dfe",
    opacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7117",
    "data-name": "Path 7117",
    d: "M1009.1,2318.472l-.224-.418-38.593-71.985,45.087-24.172,7.531,14.043,31.286,58.36-.417.224Zm-37.534-72.016,37.922,70.733,43.417-23.277-30.839-57.525h0l-7.083-13.208-5.629,3.019Z",
    transform: "translate(343.578 -1702.891)",
    fill: "#ccd5ff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_529",
    "data-name": "Ellipse 529",
    cx: 31.344,
    cy: 31.344,
    r: 31.344,
    transform: "translate(1509.557 469.345)",
    fill: "#3a7ec1",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_530",
    "data-name": "Ellipse 530",
    cx: 31.344,
    cy: 31.344,
    r: 31.344,
    transform: "translate(1506.453 469.345)",
    fill: "#f9c067"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7118",
    "data-name": "Path 7118",
    d: "M3337.569,1344.51s33.3-102.02,32.357-102.02-11.132-1.895-11.132-1.895Z",
    transform: "translate(-1826.184 -803.47)",
    fill: "#3a7ec1",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7119",
    "data-name": "Path 7119",
    d: "M2601.3,2347.8l39.554-62.911-39.554-11.075Z",
    transform: "translate(-1151.349 -1750.479)",
    fill: "#3a7ec1",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7121",
    "data-name": "Path 7121",
    d: "M934.773,2277.828l-44.252,23.725-38.369-71.568,38.206-20.483,6.047-3.242,7.307,13.626Z",
    transform: "translate(451.85 -1688.559)",
    fill: "#3b82f4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_531",
    "data-name": "Ellipse 531",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1318.989 555.319) rotate(-10.968)",
    fill: "#b3cef6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7126",
    "data-name": "Path 7126",
    d: "M1187.789,2490.486l-22.085,11.84a1.873,1.873,0,0,1-2.535-.765h0a1.873,1.873,0,0,1,.766-2.535l22.086-11.841a1.872,1.872,0,0,1,2.535.766h0A1.873,1.873,0,0,1,1187.789,2490.486Z",
    transform: "translate(166.988 -1945.839)",
    fill: "#b3cef6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_532",
    "data-name": "Ellipse 532",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1326.185 566.527) rotate(-0.752)",
    fill: "#b3cef6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7127",
    "data-name": "Path 7127",
    d: "M1265.452,2635.347l-22.086,11.84a1.872,1.872,0,0,1-2.535-.765h0a1.873,1.873,0,0,1,.766-2.535l22.085-11.84a1.872,1.872,0,0,1,2.535.766h0A1.872,1.872,0,0,1,1265.452,2635.347Z",
    transform: "translate(95.805 -2078.614)",
    fill: "#b3cef6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_533",
    "data-name": "Ellipse 533",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1332.724 578.555)",
    fill: "#b3cef6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7128",
    "data-name": "Path 7128",
    d: "M1343.115,2780.209l-22.085,11.84a1.872,1.872,0,0,1-2.535-.765h0a1.873,1.873,0,0,1,.765-2.535l22.085-11.841a1.873,1.873,0,0,1,2.535.766h0A1.873,1.873,0,0,1,1343.115,2780.209Z",
    transform: "translate(24.623 -2211.388)",
    fill: "#b3cef6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_534",
    "data-name": "Ellipse 534",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1339.203 590.642)",
    fill: "#b3cef6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7129",
    "data-name": "Path 7129",
    d: "M1420.777,2925.071l-22.086,11.84a1.872,1.872,0,0,1-2.535-.766h0a1.872,1.872,0,0,1,.766-2.535l22.085-11.841a1.873,1.873,0,0,1,2.535.766h0A1.873,1.873,0,0,1,1420.777,2925.071Z",
    transform: "translate(-46.56 -2344.163)",
    fill: "#b3cef6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7130",
    "data-name": "Path 7130",
    d: "M1277.233,2219.886l-5.909,11.819-2.9,5.808-7.728,15.454-1.014,2.025.144-1.558,1.1-11.9.412-4.471,1.1-11.94.239-2.6.306-3.316.151-1.641.746-8.065,6.047-3.242Z",
    transform: "translate(78.328 -1688.559)",
    fill: "#3a7ec1",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7131",
    "data-name": "Path 7131",
    d: "M3416.707,1896.3a4.408,4.408,0,0,1-2.985-1.593l-8.466-10.3a4.42,4.42,0,1,1,6.831-5.612l5.659,6.889,17.622-14.479a4.421,4.421,0,1,1,5.612,6.831l-21.037,17.284A4.411,4.411,0,0,1,3416.707,1896.3Z",
    transform: "translate(-1887.303 -1380.539)",
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_535",
    "data-name": "Ellipse 535",
    cx: 11.952,
    cy: 11.952,
    r: 11.952,
    transform: "translate(1436.783 546.7) rotate(-45)",
    fill: "#f2f2f2",
    opacity: 0.28
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7135",
    "data-name": "Path 7135",
    d: "M2198.771,991.5l-29.221,105.866a9.386,9.386,0,1,1-18.1-4.994l5.291-19.174-93.848-25.9,20.8-75.377Z",
    transform: "translate(-657.871 -557.213)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7136",
    "data-name": "Path 7136",
    d: "M2328.662,1140.2l-.654,2.367-82.533-22.775,2.358-8.546C2261.918,1116.236,2328.662,1140.2,2328.662,1140.2Z",
    transform: "translate(-825.215 -684.913)",
    fill: "#3a7ec1",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7137",
    "data-name": "Path 7137",
    d: "M3081.748,1483.543a12.7,12.7,0,0,0-8.318.531l-12.253,44.4,13.2,3.642-7.937,28.764c-.945,3.425-.421,6.777,1.142,8.862,2.435-1.009,4.64-3.695,5.611-7.214l7.882-28.564,9.429-34.169.153-.556A12.761,12.761,0,0,0,3081.748,1483.543Z",
    transform: "translate(-1572.855 -1025.722)",
    fill: "#3a7ec1",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7138",
    "data-name": "Path 7138",
    d: "M2006.08,1272.073l-99.325-27.409a13.094,13.094,0,0,1-9.138-16.106l20.192-73.172,78.3,21.606-3.395,12.3a12.7,12.7,0,0,1,5.091-7.133c.295-.2.6-.394.912-.571a12.762,12.762,0,0,1,18.6,14.494l-17.783,64.444A9.387,9.387,0,0,0,2006.08,1272.073Z",
    transform: "translate(-505.946 -725.37)",
    fill: "#5b97ef"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7150",
    "data-name": "Path 7150",
    d: "M3.782-5.183c0,.526-.292.869-.944.869H1.86V-6.027h.978C3.489-6.027,3.782-5.7,3.782-5.183ZM.69-7v5.833H1.86V-3.437h.552L3.7-1.164H5.052l-1.4-2.365a1.684,1.684,0,0,0,1.329-1.68C4.985-6.186,4.283-7,2.879-7ZM9.514-7H6.13v5.841H9.514v-.953H7.3V-3.662H9.264V-4.59H7.3V-6.052H9.514ZM11.578-4.1a1.752,1.752,0,0,1,1.788-1.93,1.75,1.75,0,0,1,1.78,1.93,1.764,1.764,0,0,1-1.78,1.947A1.766,1.766,0,0,1,11.578-4.1Zm4.771,0A2.913,2.913,0,0,0,13.367-7.08,2.93,2.93,0,0,0,10.375-4.1a2.932,2.932,0,0,0,2.992,2.992,3.142,3.142,0,0,0,.752-.092L15-.136h1.454l-1.337-1.5A2.946,2.946,0,0,0,16.35-4.1Zm.953.7a2.158,2.158,0,0,0,2.331,2.29,2.2,2.2,0,0,0,2.382-2.29V-7H20.837v3.61a1.085,1.085,0,0,1-1.187,1.22,1.082,1.082,0,0,1-1.178-1.22V-7H17.3ZM26.611-7H23.227v5.841h3.384v-.953H24.4V-3.662h1.964V-4.59H24.4V-6.052h2.214Zm5.223,4.153c0-2.056-2.992-1.4-2.992-2.574,0-.476.343-.7.8-.685a.77.77,0,0,1,.836.694h1.287A1.843,1.843,0,0,0,29.678-7.08c-1.2,0-2.056.635-2.056,1.688-.008,2.114,3,1.354,3,2.616,0,.418-.326.71-.877.71a.8.8,0,0,1-.886-.777H27.606c.017,1.1.953,1.738,2.164,1.738A1.84,1.84,0,0,0,31.834-2.852Zm.785-3.2h1.554v4.888h1.17V-6.052H36.9V-7H32.62Zm9.292,3.2c0-2.056-2.992-1.4-2.992-2.574,0-.476.343-.7.8-.685a.77.77,0,0,1,.836.694h1.287A1.843,1.843,0,0,0,39.756-7.08c-1.2,0-2.056.635-2.056,1.688-.008,2.114,3,1.354,3,2.616,0,.418-.326.71-.877.71a.8.8,0,0,1-.886-.777H37.683c.017,1.1.953,1.738,2.164,1.738A1.84,1.84,0,0,0,41.912-2.852Z",
    transform: "translate(1314.177 553.339) rotate(-30)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7139",
    "data-name": "Path 7139",
    d: "M2817.746,1561.972l-18.315-5.054,20.359-73.777a8.773,8.773,0,1,1,13.223,8.629l-17.044,61.768A9.382,9.382,0,0,0,2817.746,1561.972Z",
    transform: "translate(-1332.948 -1019.501)",
    fill: "#3b82f4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7140",
    "data-name": "Path 7140",
    d: "M1371.612,1252.635l36.813-133.4a12.764,12.764,0,0,1,15.7-8.908l-112.041-30.918a12.668,12.668,0,0,0-15.577,8.841l-36.838,133.494Z",
    transform: "translate(78.338 -655.311)",
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_537",
    "data-name": "Ellipse 537",
    cx: 6.03,
    cy: 6.03,
    r: 6.03,
    transform: "translate(1378.401 451.619) rotate(-45)",
    fill: "#e4ecf9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7141",
    "data-name": "Path 7141",
    d: "M2042.049,1447.423l-69.257-19.112a2.959,2.959,0,0,1-2.059-3.629l.034-.125a2.959,2.959,0,0,1,3.629-2.059l69.257,19.112a2.959,2.959,0,0,1,2.059,3.629l-.035.125A2.959,2.959,0,0,1,2042.049,1447.423Z",
    transform: "translate(-573.301 -970.097)",
    fill: "#e4ecf9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_538",
    "data-name": "Ellipse 538",
    cx: 6.03,
    cy: 6.03,
    r: 6.03,
    transform: "translate(1375.399 465.518)",
    fill: "#e4ecf9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7142",
    "data-name": "Path 7142",
    d: "M1976.139,1686.27l-69.257-19.112a2.959,2.959,0,0,1-2.059-3.629l.034-.125a2.959,2.959,0,0,1,3.629-2.059l69.257,19.112a2.959,2.959,0,0,1,2.059,3.629l-.035.125A2.959,2.959,0,0,1,1976.139,1686.27Z",
    transform: "translate(-512.89 -1189.015)",
    fill: "#e4ecf9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_539",
    "data-name": "Ellipse 539",
    cx: 6.03,
    cy: 6.03,
    r: 6.03,
    transform: "translate(1369.9 485.448)",
    fill: "#e4ecf9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3976",
    "data-name": "Rectangle 3976",
    d: "M3.015,0H74.731a3.015,3.015,0,0,1,3.015,3.015v0A3.015,3.015,0,0,1,74.731,6.03H3.015A3.015,3.015,0,0,1,0,3.015v0A3.015,3.015,0,0,1,3.015,0Z",
    transform: "translate(1387.253 491.475) rotate(15.427)",
    fill: "#e4ecf9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_540",
    "data-name": "Ellipse 540",
    cx: 6.03,
    cy: 6.03,
    r: 6.03,
    transform: "translate(1361.902 511.407) rotate(-45)",
    fill: "#e4ecf9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7143",
    "data-name": "Path 7143",
    d: "M1844.317,2163.964l-69.257-19.111a2.959,2.959,0,0,1-2.059-3.629l.034-.125a2.959,2.959,0,0,1,3.629-2.059l69.257,19.112a2.959,2.959,0,0,1,2.059,3.629l-.034.125A2.96,2.96,0,0,1,1844.317,2163.964Z",
    transform: "translate(-392.066 -1626.85)",
    fill: "#e4ecf9"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_541",
    "data-name": "Ellipse 541",
    cx: 6.03,
    cy: 6.03,
    r: 6.03,
    transform: "translate(1356.403 531.337) rotate(-45)",
    fill: "#e4ecf9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7144",
    "data-name": "Path 7144",
    d: "M1778.406,2402.811l-69.257-19.112a2.959,2.959,0,0,1-2.059-3.629l.034-.125a2.959,2.959,0,0,1,3.629-2.06L1780.01,2397a2.959,2.959,0,0,1,2.059,3.629l-.034.125A2.959,2.959,0,0,1,1778.406,2402.811Z",
    transform: "translate(-331.655 -1845.768)",
    fill: "#e4ecf9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_542",
    "data-name": "Ellipse 542",
    cx: 6.03,
    cy: 6.03,
    r: 6.03,
    transform: "translate(1350.903 551.266) rotate(-45)",
    fill: "#e4ecf9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7145",
    "data-name": "Path 7145",
    d: "M1712.5,2641.658l-69.257-19.112a2.959,2.959,0,0,1-2.059-3.629l.034-.125a2.96,2.96,0,0,1,3.629-2.06l69.257,19.112a2.959,2.959,0,0,1,2.06,3.629l-.035.125A2.959,2.959,0,0,1,1712.5,2641.658Z",
    transform: "translate(-271.244 -2064.685)",
    fill: "#e4ecf9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7146",
    "data-name": "Path 7146",
    d: "M1706.423,1607.565a1.61,1.61,0,0,1-.975-.76l-2.405-4.238a1.615,1.615,0,0,1,2.81-1.595l1.608,2.834,7.249-4.113a1.615,1.615,0,0,1,1.594,2.81l-8.654,4.91A1.61,1.61,0,0,1,1706.423,1607.565Z",
    transform: "translate(-327.85 -1132.411)",
    fill: "#f9c067"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7147",
    "data-name": "Path 7147",
    d: "M1578.492,2071.16a1.612,1.612,0,0,1-.975-.76l-2.405-4.239a1.615,1.615,0,0,1,2.81-1.595l1.608,2.834,7.249-4.114a1.615,1.615,0,0,1,1.594,2.81l-8.653,4.91A1.612,1.612,0,0,1,1578.492,2071.16Z",
    transform: "translate(-210.594 -1557.323)",
    fill: "#f9c067"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7148",
    "data-name": "Path 7148",
    d: "M1510.636,2317.057a1.611,1.611,0,0,1-.975-.76l-2.405-4.239a1.615,1.615,0,1,1,2.81-1.594l1.608,2.833,7.248-4.113a1.615,1.615,0,1,1,1.594,2.81l-8.653,4.91A1.612,1.612,0,0,1,1510.636,2317.057Z",
    transform: "translate(-148.399 -1782.703)",
    fill: "#f9c067"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7149",
    "data-name": "Path 7149",
    d: "M1446.671,2548.854a1.612,1.612,0,0,1-.975-.76l-2.405-4.239a1.616,1.616,0,0,1,2.81-1.595l1.608,2.834,7.249-4.114a1.616,1.616,0,0,1,1.594,2.81l-8.653,4.91A1.611,1.611,0,0,1,1446.671,2548.854Z",
    transform: "translate(-89.771 -1995.158)",
    fill: "#f9c067"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Union_18",
    "data-name": "Union 18",
    d: "M14255.421-1116.457l-2.931-2.931-2.931,2.931a1.489,1.489,0,0,1-1.06.44,1.489,1.489,0,0,1-1.06-.44,1.5,1.5,0,0,1,0-2.122l2.931-2.93-2.931-2.931a1.5,1.5,0,0,1,0-2.122,1.5,1.5,0,0,1,2.119,0l2.932,2.932,2.93-2.929a1.5,1.5,0,0,1,2.121,0,1.494,1.494,0,0,1,0,2.118l-2.931,2.931,2.931,2.931a1.493,1.493,0,0,1,.44,1.063,1.491,1.491,0,0,1-.44,1.059,1.494,1.494,0,0,1-1.061.44A1.494,1.494,0,0,1,14255.421-1116.457Z",
    transform: "translate(-12875.102 1612.447)",
    fill: "#fc7886"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRequest);
export default __webpack_public_path__ + "static/media/empty-request.bb3045f0.svg";
export { ForwardRef as ReactComponent };